/* eslint-disable react/destructuring-assignment */
import React, { useState } from "react";
import CustomData from "pages/_components/CustomData/CustomData";
import FormattedAmount from "pages/_components/FormattedAmount";
import GridTable from "pages/_components/GridTable/GridTable";
import { bool, func, shape } from "prop-types";
import Button from "pages/_components/Button";
import { useAccount } from "hooks/useAccounts";
import { TransactionSign } from "pages/_components/TransactionCard";
import * as i18n from "util/i18n";

const RefillsSummaryBody = ({ formData, isRecipt, isSuccessRecipt, showMoreData, setShowMoreData, isDesktop }) => {
    const { formatAccountBody } = useAccount();

    const [buttonLabel, setButtonLabel] = useState("echecks.seeMore.button");

    const handleSeeMoreData = () => {
        setShowMoreData(!showMoreData);
        if (!showMoreData) {
            setButtonLabel("echecks.seeLess.button");
        } else {
            setButtonLabel("echecks.seeMore.button");
        }
    };
    return (
        <>
            {!isRecipt && (
                <GridTable className="form-summary echeq-emit refills-transaction">
                    <GridTable.Container columns={3} rows={formData?.business?.size}>
                        <GridTable.Data columnStart={1} rowStart={1}>
                            <CustomData titleText="Empresa" titleTextType="text" valueText={formData?.empresa} />
                        </GridTable.Data>
                        {formData?.business?.map((element, index) => {
                            if (element.label === "Importe") {
                                return (
                                    <GridTable.Data columnStart={3} rowStart={index}>
                                        <CustomData
                                            titleText="forms.inputFile.massivePayments.totalAmount"
                                            titleTextType="I18N"
                                            valueText={
                                                <FormattedAmount
                                                    className="data-label"
                                                    currency="ARS"
                                                    quantity={formData?.amount?.quantity}
                                                />
                                            }
                                        />
                                    </GridTable.Data>
                                );
                            }

                            return (
                                <GridTable.Data columnStart={2} rowStart={1}>
                                    <CustomData
                                        titleText={element.label}
                                        titleTextType="text"
                                        valueText={formData[`p_${element.position}`]}
                                    />
                                </GridTable.Data>
                            );
                        })}
                    </GridTable.Container>
                    <GridTable.Container columns={3} rows={2}>
                        <GridTable.Data columnStart={1} rowStart={1}>
                            <CustomData
                                titleText="massive.echeck.debit.account"
                                titleTextType="I18N"
                                valueText={formatAccountBody(formData?.accountInfo)}
                            />
                        </GridTable.Data>
                        <GridTable.Data columnStart={2} rowStart={1}>
                            <CustomData
                                titleText="payments.service.paymentId"
                                titleTextType="I18N"
                                valueText="0050025688188"
                            />
                        </GridTable.Data>
                    </GridTable.Container>
                </GridTable>
            )}
            {isRecipt && (
                <div className="ticket__body refills-transaction">
                    <div className="ticket-header-info ">
                        <CustomData titleText="Empresa" titleTextType="text" valueText={formData?.empresa} />
                        {formData?.business?.map((element) => {
                            let returnElement;
                            if (element.label === "Importe") {
                                returnElement = (
                                    <CustomData
                                        dataClass={`amount tag ${
                                            isSuccessRecipt ? "tag-echeq-character" : "tag-warning"
                                        }`}
                                        titleText="forms.inputFile.massivePayments.totalAmount"
                                        titleTextType="I18N"
                                        valueText={
                                            <FormattedAmount
                                                className="data-label"
                                                currency="ARS"
                                                quantity={formData[`p_${element.position}`]}
                                            />
                                        }
                                    />
                                );
                            }
                            return returnElement;
                        })}
                    </div>
                    <div className="view-more-data-button" id="element-to-ignore">
                        <div className="ticket__divider inside-ticket__body">
                            <div className="ticket__notch ticket__notch--left"> </div>
                            <div className="ticket__notch ticket__notch--right"> </div>
                        </div>
                        <Button
                            aria-expanded={showMoreData ? "true" : "false"}
                            className="more-button"
                            label={buttonLabel}
                            bsStyle="link"
                            onClick={handleSeeMoreData}
                            image={showMoreData ? "figma/icon/arrow-up.svg" : "figma/icon/arrow-down.svg"}
                        />
                    </div>
                    <div className={`view-more-data ${showMoreData ? "expand " : "collapse"}`}>
                        <h2>{i18n.get("creditBill.aditionalData.label")}</h2>
                        <div />
                        {formData?.business?.map((element) => {
                            let returnElement;
                            if (element.label === "Nro Linea") {
                                returnElement = (
                                    <CustomData titleText="Nro Linea" valueText={formData[`p_${element.position}`]} />
                                );
                            }
                            return returnElement;
                        })}
                        <CustomData
                            titleText="massive.echeck.debit.account"
                            titleTextType="I18N"
                            valueText={formData?.accountInfo?.accountType + formatAccountBody(formData?.accountInfo)}
                        />
                        <CustomData
                            titleText="payments.service.paymentId"
                            titleTextType="I18N"
                            valueText="0050025688188"
                        />
                        <CustomData
                            titleText="payments.service.operationId"
                            titleTextType="I18N"
                            valueText="123456789"
                        />
                        <TransactionSign isDesktop={isDesktop} showMoreData={showMoreData} />
                    </div>
                </div>
            )}
        </>
    );
};

RefillsSummaryBody.propTypes = {
    formData: shape().isRequired,
    isRecipt: bool,
    isSuccessRecipt: bool,
    showMoreData: bool,
    isDesktop: bool,
    setShowMoreData: func,
};
RefillsSummaryBody.defaultProps = {
    isRecipt: false,
    isSuccessRecipt: false,
    showMoreData: false,
    isDesktop: false,
    setShowMoreData: () => {},
};
export default RefillsSummaryBody;
